import React from "react";
import { ShoppingCartIcon, Volume2, VolumeX } from "lucide-react";

import { openCart } from "../../cart-widget/cartControls";
import { usePlaylist } from "../../media-widget/hooks/usePlaylistContext";
import { useIsMobile } from "../../utils/useMediaQuery";

const MediaControls: React.FC = () => {
  const { mediaItems, currentMediaIndex, isMuted, setIsMuted } = usePlaylist();
  const isMobile = useIsMobile();
  const currentMedia = mediaItems[currentMediaIndex];

  return (
    <div className="flex h-full w-full flex-col items-end justify-end gap-4 text-black">
      {currentMedia?.type === "video" && (
        <button
          className="rounded-full bg-black/20 p-2 text-white hover:bg-black/40"
          onClick={() => setIsMuted(!isMuted)}
        >
          {isMuted ? <VolumeX size={24} /> : <Volume2 size={24} />}
        </button>
      )}
      {isMobile && (
        <>
          <button
            className="rounded-full bg-black/20 p-2 text-white hover:bg-black/40 sm:hidden sm:bg-transparent"
            onClick={openCart}
          >
            <ShoppingCartIcon size={24} />
          </button>
        </>
      )}
    </div>
  );
};

export default MediaControls;
